<div class="header">
    <div class="logo header-content"></div>
    <ul class="user-actions header-content">
      <li ><a routerLink="/login">Sign in </a></li>
      
    </ul>
  </div>
  <div class="nav">
    <ul class="nav-options">
      <li>Our Product</li>
      <li>Plans</li>
      <li>Help</li>
      <li>Contact</li>
    </ul>
  </div>  
<html>
    <head><meta name="viewport" content="width=device-width, initial-scale=1.0"></head> 
<div align="center">
    <form #Fillit="ngForm"><br>
        Please enter your registered email-id below : <br> <br>
            <input  type="text" required [(ngModel)]="user['email_id']" name="email_id" #email_id="ngModel"
            class="w-30" placeholder="Regsitered Email-Id"> <br><br>
        <button class="btn primary-btn" type="submit" (click)="lookUp()" value="">Claim Password</button>
        </form>
      </div>
</html>

